
export class Menus {

    public static translate(rawMenuList) {
      console.log(rawMenuList)
        let ret = [];
        let idx, jdx, zdx;

        rawMenuList = rawMenuList || [];

        let top, sub, ref, obj, refobj;

        for (idx = 0; idx < rawMenuList.length; idx++) {

            top = {};
            top.name    = rawMenuList[idx].title;
            top.icon    = rawMenuList[idx].icon;
            top.url     = rawMenuList[idx].href;

            if (rawMenuList[idx].childs && rawMenuList[idx].childs.length) {

                top.submenu = [];


                for (jdx = 0; jdx < rawMenuList[idx].childs.length; jdx++) {

                    sub = {};

                    ref         = rawMenuList[idx].childs[jdx];
                    sub.name    = ref.title;
                    // sub.icon    = ref.menu_icon;
                    sub.url     = ref.href;

                    if (this.isExternal(ref.href)) {
                        sub.slug = 'external';
                        sub.target = '_blank';
                    }

                    top.submenu.push(sub);

                    // if(rawMenuList[idx].children[jdx].children && rawMenuList[idx].children[jdx].children.length){
                        
                    //     sub.submenu = [];

                    //     for (zdx = 0; zdx < rawMenuList[idx].children[jdx].children.length; zdx++) {

                    //         obj = {};
        
                    //         refobj      = rawMenuList[idx].children[jdx].children[zdx];
                    //         obj.name    = refobj.menu_name;
                    //         // obj.icon    = refobj.menu_icon;
                    //         obj.url     = refobj.target_url;
        
                    //         if (this.isExternal(refobj.target_url)) {
                    //             obj.slug = 'external';
                    //             obj.target = '_blank';
                    //         }
        
                    //         sub.submenu.push(obj);
                    //     }
                    // }
                    

                }

            }

            if (this.isExternal(top.url)) {
                top.slug = 'external';
                top.target = '_blank';
            }

            ret.push(top);

        }
        console.log(ret)
        return ret;
    }

    public static isExternal(url) {
        // console.log(url)
        let ret = false;
        // url = url.toLowerCase();
        let regex = new RegExp('^http[s]?://', 'i');
        // console.log(['test-isExternal', url]);
        if (regex.test(url)) {
            // console.log('detect http external url', url);
            ret = true;
        }
        return ret;
    }


}
